module.exports = __webpack_public_path__ + "img/12.9756bbb6.png";